import { create } from 'zustand';
import { jwtDecode } from 'jwt-decode';

const useAuthStore = create((set, get) => ({
  user: null,
  token: null,
  isLoggingOut: false,

  login: (userData, token) => {
    set({ user: userData, token, isLoggingOut: false });
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("token", token);
  },

  logout: () => {
    set({ user: null, token: null, isLoggingOut: true });
    localStorage.removeItem("user");
    localStorage.removeItem("token");

    // Optional: small delay to allow navigation before reset
    setTimeout(() => {
      set({ isLoggingOut: false }); // Reset flag after a second
    }, 1000);
  },

  initializeAuth: () => {
    const { isLoggingOut } = get();
    if (isLoggingOut) {
      console.log("Skipping auth init due to logout.");
      return;
    }

    const storedUser = localStorage.getItem("user");
    const storedToken = localStorage.getItem("token");

    if (storedUser && storedToken) {
      try {
        const decoded = jwtDecode(storedToken);
        const now = Date.now() / 1000;

        if (decoded.exp && decoded.exp > now) {
          set({ user: JSON.parse(storedUser), token: storedToken });
        } else {
          console.warn("Token expired");
          get().logout();
        }
      } catch (err) {
        console.error("Invalid token", err);
        get().logout();
      }
    }
  },
}));

export default useAuthStore;
